import React from "react";
import Categori from "./Categori";
import Title from "./Title";
import { ProductConsumer } from "../context";

export default function Categories() {


	return (
		<ProductConsumer>
			{(value) => {
				const { categorieNames } = value;

				return (
					<section className="py-5">
						<div className="container">
							<Title center title="Kategorier" />

							<div className="row py-5">
								{categorieNames.map((item) => {
									return <Categori key={item} categoriName={item} />;
								})}
							</div>
						</div>
					</section>
				);
			}}
		</ProductConsumer>
	);
}
